<template>
  <load-area v-if="counts == null"></load-area>
  <div class="row" v-if="counts != null">
    <div class="col">
      <div class="card countBox">
        <div class="text-center head card-success">
          <h3
            class="card-title text-white m-b-0 dl text-center"
            style="padding:30px 0"
          >
            Kolayrez
          </h3>
          <!-- <img class="" src="../assets/images/background/holiday-illustration.webp" alt="Card image cap"> -->
        </div>
        <div class="card-body weather-small">
          <div class="row">
            <div
              class="col text-center"
              :class="{
                'b-l': index > 0,
                pointer: goLink[item[0]] != undefined,
              }"
              v-for="(item, index) in Object.entries(counts.Kolayrez)"
              :key="item"
              @click="go(item)"
            >
              <h1 class="m-b-0" style="font-size:24px; font-weight:400;">
                <Vue3Autocounter
                  ref="counter"
                  :startAmount="isStart ? item[1] : 0"
                  :endAmount="item[1]"
                  :duration="1"
                />
              </h1>
              <small>{{ item[0] }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-auto" style="">
      <div class="card countBox">
        <div class="text-center head card-primary">
          <h3
            class="card-title text-white m-b-0 dl text-center"
            style="padding:30px 0"
          >
            Tourscope
          </h3>
        </div>
        <div class="card-body weather-small">
          <div class="row">
            <div
              class="col text-center"
              :class="{ 'b-l': index > 0 }"
              v-for="(item, index) in Object.entries(counts.Tourscope)"
              :key="item"
            >
              <h1
                class="font-light m-b-0"
                style="font-size:24px; font-weight:400;"
              >
                <Vue3Autocounter
                  ref="counter"
                  :startAmount="isStart ? item[1] : 0"
                  :endAmount="item[1]"
                  :duration="1"
                />
              </h1>
              <small>{{ item[0] }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <usingReport></usingReport>
    </div>
    <div class="col-12">
      <queues></queues>
    </div>
    <div class="col-12">
      <providerBasedReservations></providerBasedReservations>
    </div>
    <div class="col-12 col-lg-4">
      <onlineReservationCustomer></onlineReservationCustomer>
    </div>
    <!-- <div class="col-12 col-lg-6">
      <onlineUsers></onlineUsers>
    </div> -->
    <div class="col-12 col-lg-8">
      <birthdays></birthdays>
    </div>
  </div>
</template>

<script>
import Vue3Autocounter from "vue3-autocounter";
import usingReport from "./usingReport.vue";
import onlineReservationCustomer from "./onlineReservationCustomer";
// import onlineUsers from "./onlineUsers.vue";
import queues from "./queues.vue";
import providerBasedReservations from "./providerBasedReservations.vue";
import birthdays from "./birthdays.vue";
import { mapState } from "vuex";
export default {
  name: "counts",
  components: {
    Vue3Autocounter,
    usingReport,
    onlineReservationCustomer,
    // onlineUsers,
    queues,
    providerBasedReservations,
    birthdays,
  },
  data() {
    return {
      counts: null,
      onlineReservationScatter: null,
      isStart: false,
      goLink: {
        Extranet: "/kolayrez/providers",
        Hotel: "/myHotels",
        CustomerProvider: "/customerProviders",
        UnMatchedHotelCount: "/kolayrez/match/hotelNames",
        UnMatchedProviderMarketCount: "/kolayrez/match/markets",
        UnMatchedProviderCitizenshipCount: "/kolayrez/match/citizenships",
      },
    };
  },
  created() {
    this.get();
    setInterval(() => {
      this.get();
    }, 60000);
  },
  watch: {
    counts: {
      handler(n, o) {
        if (
          n.Kolayrez.UnMatchedHotelCount +
            n.Kolayrez.UnMatchedProviderCitizenshipCount +
            n.Kolayrez.UnMatchedProviderMarketCount ==
          0
        ) {
          document.title = "Resbox Admin";
          return false;
        }

        document.title =
          n.Kolayrez.UnMatchedHotelCount +
          n.Kolayrez.UnMatchedProviderCitizenshipCount +
          n.Kolayrez.UnMatchedProviderMarketCount +
          " adet eşleşme var!";
        if (
          !this.muteAlarm &&
          (o == null ||
            n.UnMatchedHotelCount +
              n.UnMatchedProviderCitizenshipCount +
              n.UnMatchedProviderMarketCount !=
              o.UnMatchedHotelCount +
                o.UnMatchedProviderCitizenshipCount +
                o.UnMatchedProviderMarketCount)
        ) {
          let audio = new Audio("https://panel.kolayrez.com/sound/9.mp3");
          audio.play();
        }
      },
      deep: true,
    },
  },
  methods: {
    get() {
      this.$appAxiosAdmin.get(`Counts`).then((response) => {
        this.counts = response.data;
        if (!this.isStart) {
          setTimeout(() => {
            this.isStart = true;
          }, 6000);
        }
      });
    },
    go(item) {
      if (this.goLink[item[0]] != undefined) {
        this.$router.push(this.goLink[item[0]]);
      }
    },
  },
  computed: {
    ...mapState(["muteAlarm"]),
  },
};
</script>
<style scoped>
.countBox .head {
  position: relative;
}
.countBox .head h3 {
  position: relative;
  z-index: 3;
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  font-weight: 600;
  padding: 50px 0;
}
.countBox .head img {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
